import { trigger, transition, style, animate } from '@angular/animations';

export const flyInOut = trigger('flyInOut', [
  transition(':enter', [
    style({ transform: 'translateY(-100%)', opacity: 0 }),
    animate('150ms ease-out', style({ transform: 'translateY(0%)', opacity: 1 })),
  ]),
  transition(':leave', [
    style({ transform: 'translateY(0%)', opacity: 1 }),
    animate('150ms ease-out', style({ transform: 'translateY(-100%)', opacity: 0 })),
  ]),
]);

export const flyInOutSlow = trigger('flyInOutSlow', [
  transition(':enter', [
    style({ transform: 'translateY(-50%)', opacity: 0 }),
    animate('400ms 300ms ease-out', style({ transform: 'translateY(0%)', opacity: 1 })),
  ]),
  transition(':leave', [
    style({ transform: 'translateY(0%)', opacity: 1 }),
    animate('400ms 300ms ease-out', style({ transform: 'translateY(-50%)', opacity: 0 })),
  ]),
]);

export const flyInOutSlowDelayed = trigger('flyInOutSlowDelayed', [
  transition(':enter', [
    style({ transform: 'translateY(-50%)', opacity: 0 }),
    animate('400ms 700ms ease-out', style({ transform: 'translateY(0%)', opacity: 1 })),
  ]),
  transition(':leave', [
    style({ transform: 'translateY(0%)', opacity: 1 }),
    animate('400ms 700ms ease-out', style({ transform: 'translateY(-50%)', opacity: 0 })),
  ]),
]);

export const fadeInUp = (delay: string = '0ms', translateY: string = '20%') =>
  trigger('fadeInUp', [
    transition(':enter', [
      style({ transform: `translateY(${translateY})`, opacity: 0 }),
      animate(`400ms ${delay} ease-out`, style({ transform: 'translateY(0%)', opacity: 1 })),
    ]),
    transition(':leave', [
      style({ transform: 'translateY(0%)', opacity: 1 }),
      animate(`400ms ${delay} ease-out`, style({ transform: `translateY(-${translateY})`, opacity: 0 })),
    ]),
  ]);
